document.addEventListener('DOMContentLoaded', function () {
  document.body.addEventListener('click', function (e) {
    const btn = e.target.closest('.rm-toggle');
    if (!btn) return;

    // Solo actúa si el texto del botón es exactamente "Descripción completa"
    const label = btn.textContent.trim().toLowerCase();
    if (label !== 'descripción completa') return;

    e.preventDefault(); // evita cualquier acción previa del botón
    scrollToDetallazos();
  });
});

function scrollToDetallazos() {
  const el = document.getElementById('detallazos');
  if (!el) return;

  // Si tienes header fijo y tapa arriba, calcula su altura:
  const header = document.querySelector('[data-sticky-header], .site-header, header');
  const cs = header ? getComputedStyle(header) : null;
  const headerH = header && (cs.position === 'fixed' || cs.position === 'sticky') ? header.offsetHeight : 0;

  const top = el.getBoundingClientRect().top + window.scrollY - headerH;
  window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
}
